import * as yup from "yup";
import React, { useRef } from "react";
import { AnyObjectSchema } from "yup";
import Lazy from "yup/lib/Lazy";
import { Constants } from "../../helpers/Constants";
import { ComplianceOptions } from "./Home/ApplicationDetails.types";
export type FilledMoundSystemInspectionFormProps = {
  id: string;
  returnPath: string;
    title: string;
    applicationInspectionId?: number;
    applicationId?: number;

  // schema: AnyObjectSchema | Lazy<any, unknown>;
    values?: FilledMoundSystemInspectionInput;
  action: "post" | "put";
};

export type FilledMoundSystemInspectionInput = {
    filledMoundSystemId:number;
    applicationId: number;
    applicationInspectionId: number;
    drainfieldCoverComplianceId: number;
    drainfieldCoverCompliance?: ComplianceOptions;
    drainfieldCoverComment: string;
    shoulderComplianceId: number;
    shoulderCompliance?: ComplianceOptions;
    shoulderComment: string;

    slopeComplianceId: number;
    slopeCompliance?: ComplianceOptions;
    slopeComment: string;


    stablizationComplianceId: number;
    stablizationCompliance?: ComplianceOptions;
    stablizationComment: string;
    stablizationMaterial: string;
    stablizationId: number;
    stablization?: StabilizationDto;
    ownerAgentResponsible?: boolean;
    dateCreated: Date|string;
    createdBy: string;
    dateUpdated: Date;
    updatedBy: string;
    markAll: number;
    inspectionStatusId: number;
    //inspectionStatus?: ComplianceOptions;
    

};

export type StabilizationDto = {
  stablizationId: number;
  stabizationValue: string;
  sortOrder? : number;
}

export type ComplianceData = {
  id: number;
  name: string;

};

export type StabilizationData = {
  id: number;
  name: string;

};

export const schema = yup.object().shape({
  
    drainfieldCoverComplianceId: yup
    .number()
    .min(1, "Drainfield Cover Compliance is required")
    .required("Drainfield Cover Compliance is required")
    .typeError("Drainfield Cover Compliance is required"),
    drainfieldCoverComment: yup.string().nullable(true)
        .when("drainfieldCoverComplianceId", {
      is: (val: any) => val === Constants.Out_of_Compliance,
        then: yup.string().required("Drainfield Cover Comment is required")
            .typeError("Drainfield Cover Comment is required"),
        }),

    shoulderComplianceId: yup
    .number()
    .min(1, "Shoulder Compliance is required")
        .required("Shoulder Compliance is required")
        .typeError("Shoulder Compliance is required"),
    shoulderComment: yup.string().nullable(true)
        .when("shoulderComplianceId", {
      is: (val: any) => val === Constants.Out_of_Compliance,
         then: yup.string().required("Shoulder Comment is required")
         .typeError("Shoulder Comment is required"),
        }),

    slopeComplianceId: yup
    .number()
    .min(1, "Slope Compliance Wells Compliance is required")
    .required("Slope Compliance Compliance is required")
    .typeError("Slope Compliance Compliance is required"),
    slopeComment: yup.string().nullable(true)
    .when("slopeComplianceId", {
      is: (val: any) => val === Constants.Out_of_Compliance,
        then: yup.string().required("Slope Comment is required")
            .typeError("Slope Comment is required"),
    }),




    stablizationComplianceId: yup
    .number()
    .min(1, "Stabilization Compliance is required")
    .required("Stabilization Compliance is required")
    .typeError("Stabilization Compliance is required"),
    stablizationComment: yup.string().nullable(true)
     .when("stablizationComplianceId", {
      is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Stabilization Comment is required")
                .typeError("Stabilization Comment is required"),
    }),
    stablizationId: yup.number().nullable(true)
    .when("stablizationComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.number()
    .min(1, "Stablization Material is required")
    .required("Stablization Material is required")
    .typeError("Stablization Material is required"),
    }),
    ownerAgentResponsible: yup
      .mixed()
      .transform((val, orig) => {
        if (orig === '' || orig === undefined || orig === null) return null;
        if (orig === 'true' || orig === true) return true;
        if (orig === 'false' || orig === false) return false;
        return null;
      })
      .nullable(true)
      .when("stablizationComplianceId", {
        is: (val: any) => (val != Constants.Not_Applicable && val != Constants.Unobserved),
        then: yup.boolean().required("Owner/Agent Responsible selection is required"),
        otherwise: yup.boolean().nullable().notRequired(),
      }),
});
